import inmersysLarge from "./inmersys_large_logo.png";
import inmersysLogo from "./inmersys_logo.jpeg";
import inmersysLogin from "./loginInmersys.png";

export const logos = {
	inmersysLarge,
	inmersysLogin,
	inmersysLogo,
};
